import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useUpdateResource } from '../../../hooks/useUpdateResource'
import { Coupoun } from '../../../types/modules/admin/coupoun.type'
import { CustomDate } from '../../../utils/day'
import ToggleSwitch from '../../ui/ToggleSwitch'
import UpdateCoupounForm from './UpdateCoupounForm'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../../utils/formatNumber'
import DateTimeText from '../../ui/DateTimeText'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    coupoun:Coupoun
}

function CoupounItem({coupoun}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const [isActive,setIsActive] = useState(coupoun.isActive);
        const {t} = useTranslation();

        const {updateResource} = useUpdateResource();

         async function handleChangeActive(){
            const newValue = !isActive;
              setIsActive(p=>!p);
              await  updateResource(`coupon/${coupoun.id}`, {isActive:newValue}, "admin",{
                  method: "PATCH",
                  invalidateQueries:["coupons-by-admin"],
            });
            }
        

  return (
    <>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(coupoun.id)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {coupoun.code}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatNumber(coupoun.discountPercentage)}%
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatNumber(coupoun.maxUsage)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatNumber(coupoun.usedCount)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            <DateTimeText date={coupoun.startDate}/>
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            <DateTimeText date={coupoun.expiryDate??""}/>
        </td>

        <PermissionGate permissions={[PermissionsKey.UpdateCoupon]}>
            <>
            <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                <ToggleSwitch checked={isActive} onChange={handleChangeActive} size={"sm"}/>
            </td>


            <td className="p-3 min-w-[200px] text-Black font-normal">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
            </td>
            </>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateCoupounForm
        id={coupoun.id}
        defaultValues={{
            maxUsage:coupoun.maxUsage,
            startDate:coupoun.startDate,
            expiryDate:coupoun.expiryDate,
            discountPercentage:coupoun.discountPercentage,
            code:coupoun.code
        }}
        onSubmitSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default CoupounItem